import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import { formattaData } from '../utils/dateUtils';

const pdfStyles = StyleSheet.create({
  page: { padding: 20, fontSize: 8, fontFamily: 'Helvetica' },
  intestazione: { flexDirection: 'row', alignItems: 'center', marginBottom: 8, paddingBottom: 6, borderBottom: '1 solid #ccc' },
  logoImg: { width: 60, height: 24, objectFit: 'contain' },
  recapiti: { marginLeft: 10, fontSize: 7, color: '#333' },
  recapitiNome: { fontSize: 8, fontWeight: 'bold', marginBottom: 1 },
  title: { fontSize: 12, fontWeight: 'bold', textAlign: 'center', marginBottom: 8 },
  filtriBox: { backgroundColor: '#e3f2fd', padding: 8, marginBottom: 10, borderRadius: 4 },
  filtriText: { fontSize: 8, textAlign: 'center' },
  divider: { borderBottom: '1 solid #aaa', marginVertical: 4 },
  tableHeader: { flexDirection: 'row', backgroundColor: '#f8f9fa', fontWeight: 'bold', fontSize: 8, borderBottom: '1 solid #dee2e6', minHeight: 20, alignItems: 'center' },
  tableRow: { flexDirection: 'row', borderBottom: '1 solid #dee2e6', minHeight: 18, alignItems: 'center' },
  totaleRow: { flexDirection: 'row', borderTop: '2 solid #495057', minHeight: 20, alignItems: 'center', backgroundColor: '#f0f4f8', marginTop: 4 },
  totaleLabel: { width: '55%', padding: 3, fontSize: 8, fontWeight: 'bold', textAlign: 'right' },
  totaleValore: { width: '10%', padding: 3, fontSize: 8, fontWeight: 'bold', color: '#1a6e3c' },
  totaleSpacer: { width: '35%' },
  colData:     { width: '11%', padding: 3, fontSize: 7 },
  colDip:      { width: '18%', padding: 3, fontSize: 7 },
  colCantiere: { width: '18%', padding: 3, fontSize: 7 },
  colCliente:  { width: '18%', padding: 3, fontSize: 7 },
  colNumero:   { width: '10%', padding: 3, fontSize: 7 },
  colCheck:    { width: '10%', padding: 3, fontSize: 7, textAlign: 'center' },
  colPdf:      { width: '8%', padding: 3, fontSize: 7, textAlign: 'center' },
  badgeSi:     { color: '#1a6e3c', fontWeight: 'bold' },
  badgeNo:     { color: '#999' },
  footer: { position: 'absolute', bottom: 20, left: 30, right: 30, textAlign: 'center', fontSize: 7, color: '#95a5a6' },
});

export default function ListaBollePDF({ risultati, filtri, dipendentiMap }) {
  function getFiltriText() {
    const f = [];
    if (filtri.dipendenteId) {
      const d = dipendentiMap[filtri.dipendenteId];
      f.push(`Dipendente: ${d?.nome} ${d?.cognome}`);
    }
    if (filtri.dataInizio) f.push(`Dal: ${formattaData(filtri.dataInizio)}`);
    if (filtri.dataFine) f.push(`Al: ${formattaData(filtri.dataFine)}`);
    if (filtri.cliente) f.push(`Cliente: ${filtri.cliente}`);
    if (filtri.cantiere) f.push(`Cantiere: ${filtri.cantiere}`);
    if (filtri.numeroBolla) f.push(`N. Bolla: ${filtri.numeroBolla}`);
    if (filtri.fatturata !== '') f.push(`Fatturata: ${filtri.fatturata === 'true' ? 'Si' : 'No'}`);
    if (filtri.archiviata !== '') f.push(`Archiviata: ${filtri.archiviata === 'true' ? 'Si' : 'No'}`);
    return f.length > 0 ? f.join('  |  ') : 'Nessun filtro applicato';
  }

  return (
    <Document>
      <Page size="A4" orientation="landscape" style={pdfStyles.page}>
        <View style={pdfStyles.intestazione}>
          <Image src="CRG_logo.png" style={pdfStyles.logoImg} />
          <View style={pdfStyles.recapiti}>
            <Text style={pdfStyles.recapitiNome}>C.R.G. Scavi e trasporti Sagl</Text>
            <Text>Via Livio 5, 6830 Chiasso TI</Text>
          </View>
        </View>
        <Text style={pdfStyles.title}>RICERCA BOLLE</Text>
        <View style={pdfStyles.filtriBox}>
          <Text style={pdfStyles.filtriText}>{getFiltriText()}</Text>
          <Text style={{ ...pdfStyles.filtriText, marginTop: 3 }}>Totale risultati: {risultati.length}</Text>
        </View>
        <View style={pdfStyles.divider} />

        <View style={pdfStyles.tableHeader}>
          <Text style={pdfStyles.colData}>Data</Text>
          <Text style={pdfStyles.colDip}>Dipendente</Text>
          <Text style={pdfStyles.colCantiere}>Cantiere</Text>
          <Text style={pdfStyles.colCliente}>Cliente</Text>
          <Text style={pdfStyles.colNumero}>N. Bolla</Text>
          <Text style={pdfStyles.colCheck}>Fatturata</Text>
          <Text style={pdfStyles.colCheck}>Archiviata</Text>
        </View>

        {risultati.map((b, i) => (
          <View key={i} style={pdfStyles.tableRow}>
            <Text style={pdfStyles.colData}>{formattaData(b.data)}</Text>
            <Text style={pdfStyles.colDip}>{b._nomeDipendente || '-'}</Text>
            <Text style={pdfStyles.colCantiere}>{b._cantiere || '-'}</Text>
            <Text style={pdfStyles.colCliente}>{b._cliente || '-'}</Text>
            <Text style={pdfStyles.colNumero}>{b.numeroBolla || b.numero || '-'}</Text>
            <Text style={{ ...pdfStyles.colCheck, ...(b.fatturata ? pdfStyles.badgeSi : pdfStyles.badgeNo) }}>
              {b.fatturata ? 'SI' : 'No'}
            </Text>
            <Text style={{ ...pdfStyles.colCheck, ...(b.archiviata ? pdfStyles.badgeSi : pdfStyles.badgeNo) }}>
              {b.archiviata ? 'SI' : 'No'}
            </Text>
          </View>
        ))}

        <View style={pdfStyles.totaleRow}>
          <Text style={pdfStyles.totaleLabel}>TOTALE BOLLE:</Text>
          <Text style={pdfStyles.totaleValore}>{risultati.length}</Text>
          <Text style={pdfStyles.totaleSpacer}></Text>
        </View>

        <Text style={pdfStyles.footer}>
          Report generato il {new Date().toLocaleDateString('it-IT')} alle {new Date().toLocaleTimeString('it-IT')} — App Cantieri
        </Text>
      </Page>
    </Document>
  );
}